/**
 * The short name a bug report is known by — what the reporter is told, what the
 * admin email's subject carries, and what anyone can quote back.
 *
 * HQ-BUG-INTAKE-001. Workflow map, Issue report to verified resolution, step 2:
 * "assign one issue identifier and confirm successful persistence." A report had
 * only a uuid, which the reporter never saw, so "I filed a bug about the schedule
 * last week" had nothing to point at.
 *
 * Derived from the uuid rather than stored, on purpose: it needs no column and no
 * migration, it is the same everywhere without being kept in sync, and a person
 * can search for it. Eight hex characters is 4.3 billion values — ample for a
 * list that is read by hand, and the full id is still the real key.
 */
export function bugReference(id: string): string {
  const hex = String(id ?? "").replace(/[^0-9a-f]/gi, "").slice(0, 8).toUpperCase();
  return hex ? `BUG-${hex}` : "BUG-UNKNOWN";
}

/**
 * Emails per reporter inside the window below, before further reports are filed
 * without mailing the admin. A real person rarely files more than a couple in ten
 * minutes; a stuck button or a script can file hundreds, and each used to be one
 * email into the same inbox. The reports are still all filed and still listed on
 * the admin Bugs page — only the mail is held back.
 */
export const BUG_EMAIL_WINDOW_MINUTES = 10;
export const BUG_EMAIL_BURST_LIMIT = 5;

/** `recentCount` includes the report being filed right now. */
export function overBugEmailLimit(recentCount: number): boolean {
  return recentCount > BUG_EMAIL_BURST_LIMIT;
}
